import React, { useMemo, useCallback } from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { useRouter } from 'expo-router';
import LoginForm from '@/components/Forms/LoginForm';
import { APP_NAME } from '@/constants/config';
import AuthPage from '@/components/Pages/AuthPage';
import MetaHead from '@/components/MetaHead';

function LoginRoute() {
  const { t } = useTranslation();
  const router = useRouter();

  // Memoize handlers
  const handleLogoPress = useCallback(() => {
    router.push('/');
  }, [router]);

  // Memoize title
  const title = useMemo(() => 
    t('auth.login.title').replace('%APP_NAME%', APP_NAME),
    [t]
  );

  return (
    <AuthPage
      title={title}
      subtitle={t('auth.login.subtitle')}
      onLogoPress={handleLogoPress}
    >
      <MetaHead 
        title="Login"
        description="Securely access your Gab AI account. Log in to use multiple AI models, continue your conversations, and manage your AI interactions all in one place."
      />
      <LoginForm />
    </AuthPage>
  );
} 

export default React.memo(LoginRoute);